import React from 'react';

const ModalContainer = ({ children }) => {
  return <div className="admin-modal-container">{children}</div>;
};

export default ModalContainer;
